import { PageItemProps } from "apis/page";
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";

export interface PageStatistical {
    count: number;
    publish: number;
    totalViews: number;
    topPage: {
        page?: PageItemProps;
        view: number;
    }
}
type ApiPageStatisticalOutputProps = OutputBaseProps<PageStatistical>;

export const apiPageStatistical = async () => {
    const res = (await axios.get<ApiPageStatisticalOutputProps>("/api/statistical/page"))
        .data;
    return res;
};